import { Link } from 'react-router-dom';
import Logo from '../Logo';

export default function Footer() {
  return (
    <footer className="mt-20 pt-16 pb-8" style={{ background: 'linear-gradient(180deg, #EAF6FF 0%, #F8FCFF 60%, #FFFFFF 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 pb-12 border-b border-tea-100">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Logo className="h-8 w-8" />
              <span className="font-bold text-tea-600 text-xl">Aloha Amino</span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed mb-4">
              Research-grade peptides for licensed laboratories and researchers.
            </p>
            <p className="text-xs text-amber-600 leading-relaxed bg-amber-50 border border-amber-100 rounded-xl p-3">
              FOR LABORATORY RESEARCH USE ONLY. Not for human or veterinary
              consumption, diagnosis, or treatment.
            </p>
          </div>

          {/* Catalog */}
          <div>
            <h4 className="text-gray-900 font-bold mb-4 text-sm uppercase tracking-wider">Catalog</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/shop" className="text-gray-500 hover:text-tea-600 transition-colors">All Peptides</Link></li>
              <li><Link to="/shop?search=bpc" className="text-gray-500 hover:text-tea-600 transition-colors">BPC-157</Link></li>
              <li><Link to="/shop?search=ghk" className="text-gray-500 hover:text-tea-600 transition-colors">GHK-Cu</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-gray-900 font-bold mb-4 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-gray-500 hover:text-tea-600 transition-colors">About Aloha Amino</Link></li>
              <li><Link to="/support" className="text-gray-500 hover:text-tea-600 transition-colors">Lab Support</Link></li>
              <li><Link to="/coa" className="text-gray-500 hover:text-tea-600 transition-colors">COA Library</Link></li>
            </ul>
          </div>

          {/* Support & Legal */}
          <div>
            <h4 className="text-gray-900 font-bold mb-4 text-sm uppercase tracking-wider">Support &amp; Legal</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="mailto:support@alohaamino.example.com" className="text-gray-500 hover:text-tea-600 transition-colors">Contact Us</a></li>
              <li><Link to="/account" className="text-gray-500 hover:text-tea-600 transition-colors">My Account</Link></li>
              <li><Link to="/terms" className="text-gray-500 hover:text-tea-600 transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-500 hover:text-tea-600 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/compliance" className="text-gray-500 hover:text-tea-600 transition-colors">Research Use Disclosure</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom legal line */}
        <div className="pt-8 text-xs text-center text-gray-400 leading-relaxed">
          &copy; {new Date().getFullYear()} Aloha Amino Research Inc. All rights reserved.{' '}
          Products are sold for in-vitro research and laboratory use only. They are not drugs, foods, cosmetics,
          or medical devices, and have not been approved by the FDA or any other regulator for
          human or animal use. Customers represent that they are licensed researchers, medical professionals, or
          qualified laboratory providers, and must not make therapeutic, medical, or health claims.
        </div>
      </div>
    </footer>
  );
}
